import { Provider } from '@app/models';
import { Action } from '@ngrx/store';

export enum ProviderActionTypes {
  Load = '[API] Load providers',
  LoadById = '[API] Load single provider by id',
  LoadSuccess = '[API] Load providers success',
  LoadFail = '[API] Load providers fail',

  LoadByFollowGroup = '[API] Load providers by follow group',
  LoadByFollowGroupSuccess = '[API] Load providers by follow group success',
  LoadByFollowGroupFail = '[API] Load providers by follow group fail',

  AddOne = '[Provider] Add one',
  AddAll = '[Provider] Add all',
  AddRut = '[API] Add rut by provider',
  Create = '[API] Create provider',
  CreateSuccess = '[API] Create provider success',
  CreateFail = '[API] Create provider fail',
  ProviderUpdate = '[API] update provider ',
  ProviderSuccess = '[Provider]  update provider success',
  ProviderFail = '[Provider]  update provider fail',

  GetUploadLink = '[Provider] get upload file link',
  GetUploadLinkSuccess = '[Provider] upload file link success',
  GetUploadLinkFail = '[Provider] upload file link fail',

  UploadFile = '[Provider] upload file',
  UploadFileSuccess = '[Provider] upload file success',
  UploadFileFail = '[Provider] upload file fail',

  UploadProcessUpdate = '[Provider] upload file process update',
  UploadProcessSuccess = '[Provider] upload file process success',
  UploadProcessFail = '[Provider] upload file process fail',

  Archived = '[API] Archived provider',
  ArchivedSuccess = '[API] Archived provider success',
  ArchivedFail = '[API] Archived provider fail',
  RemoveOne = '[Provider] Remove one',
  RemoveOneSuccess = '[Provider] Remove one success',
  RemoveOneFailed = '[Provider] Remove one failed',

  Search = '[Search] Search provider',
  SearchSuccess = '[Search] Search provider success',
  SearchFail = '[Search] Search provider fail',

  SearchClear = '[Search] Seacrh clear provider',

  SearchPro = '[Search] Search provider pro',
  SearchSuccessPro = '[Search] Search provider success pro',
  SearchFailPro = '[Search] Search provider fail pro',

  SearchClearPro = '[Search] Seacrh clear provider pro',

  ClearState = '[Provider] Clear state',

  UpdateManagement = '[Provider] update provider management',
  UpdateManagementSuccess = '[Provider] update provider management success',
  UpdateManagementFail = '[Provider] update provider management fail',

  CreateManagement = '[Provider] create provider management',
  CreateManagementSuccess = '[Provider] create provider management success',
  CreateManagementFail = '[Provider] create provider management fail',

  AddResponsable = '[Provider] add provider responsable',
  AddResponsableSuccess = '[Provider] add provider responsable success',
  AddResponsableFail = '[Provider] add provider responsable fail',
  
  DeleteResponsable = '[Provider] delete provider responsable',
  DeleteResponsableSuccess = '[Provider] delete provider responsable success',
  DeleteResponsableFail = '[Provider] delete provider responsable fail',

  LoadSupplier = '[Provider] load supplier',

  ProviderRebate = '[Provider] provider rebate',
  ProviderRebateSuccess = '[Provider] provider rebate success',
  ProviderRebateFail = '[Provider] provider rebate fail',

  ProviderCreateRebate = '[Provider] provider create rebate',
  ProviderCreateRebateSuccess = '[Provider] provider create rebate success',
  ProviderCreateRebateFail = '[Provider] provider create rebate fail',

  SyncMdm = "[Provider] sync mdm",
  SyncMdmSuccess = "[Provider] sync mdm success",
  SyncMdmFail = "[Provider] sync mdm fail",
  SyncMdmPending = "[Provider] sync mdm pending",
}

export class SyncMdm implements Action {
  readonly type = ProviderActionTypes.SyncMdm;
  constructor(public data?: any) {}
}

export class SyncMdmSuccess implements Action {
  readonly type = ProviderActionTypes.SyncMdmSuccess;
  constructor(public data?: any) {}
}

export class SyncMdmFail implements Action {
  readonly type = ProviderActionTypes.SyncMdmFail;
  constructor(public error?: any) {}
}

export class SyncMdmPending implements Action {
  readonly type = ProviderActionTypes.SyncMdmPending;
  constructor(public data?: any) {}
}

export class LoadSupplier implements Action {
  readonly type = ProviderActionTypes.LoadSupplier;
  constructor(public followGroupId?: number) {}
}

export class Load implements Action {
  readonly type = ProviderActionTypes.Load;
  constructor(public page?: any, public filterValue?: any, public viewMode?: string) {}
}

export class LoadById implements Action {
  readonly type = ProviderActionTypes.LoadById;
  constructor(public ProviderId: number) {}
}

export class LoadByFollowGroup implements Action {
  readonly type = ProviderActionTypes.LoadByFollowGroup;
  constructor(public id: number, public gerencyMode?: string) {}
}

export class LoadSuccess implements Action {
  readonly type = ProviderActionTypes.LoadSuccess;
  constructor(public providers: any) {}
}

export class LoadByFollowGroupSuccess implements Action {
  readonly type = ProviderActionTypes.LoadByFollowGroupSuccess;
  constructor(public providers: Provider[]) {}
}

export class LoadFail implements Action {
  readonly type = ProviderActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class LoadByFollowGroupFail implements Action {
  readonly type = ProviderActionTypes.LoadByFollowGroupFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = ProviderActionTypes.Create;
  constructor(public provider: Provider) {}
}

export class CreateSuccess implements Action {
  readonly type = ProviderActionTypes.CreateSuccess;
  constructor(public provider: Provider) {}
}

export class CreateFail implements Action {
  readonly type = ProviderActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = ProviderActionTypes.AddOne;
  constructor(public provider: Provider) {}
}

export class AddAll implements Action {
  readonly type = ProviderActionTypes.AddAll;
  constructor(public providers: Provider[]) {}
}

export class UpdateManagement implements Action {
  readonly type = ProviderActionTypes.UpdateManagement;
  constructor(public id: number, public data: any) {}
}

export class UpdateManagementSuccess implements Action {
  readonly type = ProviderActionTypes.UpdateManagementSuccess;
  constructor(public data: any) {}
}

export class UpdateManagementFail implements Action {
  readonly type = ProviderActionTypes.UpdateManagementFail;
  constructor(public data: any) {}
}

export class CreateManagement implements Action {
  readonly type = ProviderActionTypes.CreateManagement;
  constructor(public data: any) {}
}

export class CreateManagementSuccess implements Action {
  readonly type = ProviderActionTypes.CreateManagementSuccess;
  constructor(public data: any) {}
}

export class CreateManagementFail implements Action {
  readonly type = ProviderActionTypes.CreateManagementFail;
  constructor(public data: any) {}
}

export class AddResponsable implements Action {
  readonly type = ProviderActionTypes.AddResponsable;
  constructor(public data: any) {}
}

export class AddResponsableSuccess implements Action {
  readonly type = ProviderActionTypes.AddResponsableSuccess;
  constructor(public data: any) {}
}

export class AddResponsableFail implements Action {
  readonly type = ProviderActionTypes.AddResponsableFail;
  constructor(public data: any) {}
}

export class DeleteResponsable implements Action {
  readonly type = ProviderActionTypes.DeleteResponsable;
  constructor(public id: number, public data: any) {}
}

export class DeleteResponsableSuccess implements Action {
  readonly type = ProviderActionTypes.DeleteResponsableSuccess;
  constructor(public data: any) {}
}

export class DeleteResponsableFail implements Action {
  readonly type = ProviderActionTypes.DeleteResponsableFail;
  constructor(public data: any) {}
}

export class Update implements Action {
  readonly type = ProviderActionTypes.ProviderUpdate;
  constructor(public id: number, public rut: any) {}
}
export class UpdateFail implements Action {
  readonly type = ProviderActionTypes.ProviderFail;
  constructor(public error: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = ProviderActionTypes.ProviderSuccess;
  constructor(public data: any) {}
}

export class GetUploadLink implements Action {
  readonly type = ProviderActionTypes.GetUploadLink;
  constructor(public file: any) {}
}

export class GetUploadLinkSuccess implements Action {
  readonly type = ProviderActionTypes.GetUploadLinkSuccess;
  constructor(public data: any) {}
}

export class GetUploadLinkFail implements Action {
  readonly type = ProviderActionTypes.GetUploadLinkFail;
  constructor() {}
}

export class UploadFile implements Action {
  readonly type = ProviderActionTypes.UploadFile;
  constructor(
    public uploadUrl: string,
    public FileId: number,
    public file: any
  ) {}
}

export class UploadFileSuccess implements Action {
  readonly type = ProviderActionTypes.UploadFileSuccess;
  constructor(public FileId: number) {}
}

export class UploadFileFail implements Action {
  readonly type = ProviderActionTypes.UploadFileFail;
  constructor(public error: any) {}
}

export class UploadProcessUpdate implements Action {
  readonly type = ProviderActionTypes.UploadProcessUpdate;
  constructor(public data: any) {}
}

export class UploadProcessSuccess implements Action {
  readonly type = ProviderActionTypes.UploadProcessSuccess;
  constructor() {}
}

export class UploadProcessFail implements Action {
  readonly type = ProviderActionTypes.UploadProcessFail;
  constructor(public error: any) {}
}

export class Archived implements Action {
  readonly type = ProviderActionTypes.Archived;
  constructor(public id: number) {}
}

export class ArchivedSuccess implements Action {
  readonly type = ProviderActionTypes.ArchivedSuccess;
  constructor(public id: number) {}
}

export class ArchivedFail implements Action {
  readonly type = ProviderActionTypes.ArchivedFail;
  constructor(public id: number) {}
}

export class RemoveOne implements Action {
  readonly type = ProviderActionTypes.RemoveOne;
  constructor(public id: number) {}
}

export class RemoveOneSuccess implements Action {
  readonly type = ProviderActionTypes.RemoveOneSuccess;
  constructor(public id: number) {}
}

export class RemoveOneFailed implements Action {
  readonly type = ProviderActionTypes.RemoveOneFailed;
  constructor(public error: any) {}
}

export class Search implements Action {
  readonly type = ProviderActionTypes.Search;
  constructor(public data: any, public FollowId?: number) {}
}

export class SearchSuccess implements Action {
  readonly type = ProviderActionTypes.SearchSuccess;
  constructor(public ProviderIds: number[]) {}
}

export class SearchFail implements Action {
  readonly type = ProviderActionTypes.SearchFail;
  constructor(public error: any) {}
}

export class SearchClear implements Action {
  readonly type = ProviderActionTypes.SearchClear;
  constructor() {}
}

export class SearchPro implements Action {
  readonly type = ProviderActionTypes.SearchPro;
  constructor(public data: any, public FollowId: number) {}
}

export class SearchSuccessPro implements Action {
  readonly type = ProviderActionTypes.SearchSuccessPro;
  constructor(public ProviderIds: number[]) {}
}

export class SearchFailPro implements Action {
  readonly type = ProviderActionTypes.SearchFailPro;
  constructor(public error: any) {}
}

export class ProviderRebate implements Action {
  readonly type = ProviderActionTypes.ProviderRebate;
  constructor(public FollowId: number) {}
}

export class ProviderRebateSuccess implements Action {
  readonly type = ProviderActionTypes.ProviderRebateSuccess;
  constructor(public data: any) {}
}

export class ProviderRebateFail implements Action {
  readonly type = ProviderActionTypes.ProviderRebateFail;
  constructor(public error: any) {}
}

export class ProviderCreateRebate implements Action {
  readonly type = ProviderActionTypes.ProviderCreateRebate;
  constructor(public FollowId: number, public data: any) {}
}

export class ProviderCreateRebateSuccess implements Action {
  readonly type = ProviderActionTypes.ProviderCreateRebateSuccess;
  constructor(public data: any) {}
}

export class ProviderCreateRebateFail implements Action {
  readonly type = ProviderActionTypes.ProviderCreateRebateFail;
  constructor(public error: any) {}
}

export class SearchClearPro implements Action {
  readonly type = ProviderActionTypes.SearchClearPro;
  constructor() {}
}

export class ClearState implements Action {
  readonly type = ProviderActionTypes.ClearState;
  constructor() {}
}

export type ProviderActionsUnion =
  | Load
  | LoadById
  | LoadByFollowGroup
  | LoadByFollowGroupSuccess
  | LoadByFollowGroupFail
  | LoadSuccess
  | LoadFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddAll
  | AddOne
  | Update
  | UpdateFail
  | UpdateSuccess
  | GetUploadLink
  | GetUploadLinkSuccess
  | GetUploadLinkFail
  | UploadFile
  | UploadFileSuccess
  | UploadFileFail
  | UploadProcessUpdate
  | UploadProcessSuccess
  | UploadProcessFail
  | Archived
  | ArchivedSuccess
  | ArchivedFail
  | RemoveOne
  | RemoveOneSuccess
  | RemoveOneFailed
  | Search
  | SearchSuccess
  | SearchFail
  | SearchClear
  | SearchPro
  | SearchSuccessPro
  | SearchFailPro
  | SearchClearPro
  | ClearState
  | UpdateManagement
  | UpdateManagementSuccess
  | UpdateManagementFail
  | CreateManagement
  | CreateManagementSuccess
  | CreateManagementFail
  | AddResponsable
  | AddResponsableSuccess
  | AddResponsableFail
  | DeleteResponsable
  | DeleteResponsableSuccess
  | DeleteResponsableFail
  | LoadSupplier
  | ProviderRebate
  | ProviderRebateSuccess
  | ProviderRebateFail
  | ProviderCreateRebate
  | ProviderCreateRebateSuccess
  | ProviderCreateRebateFail
  | SyncMdm
  | SyncMdmSuccess
  | SyncMdmFail
  | SyncMdmPending;
